import { render, staticRenderFns } from "./ItSupport.vue?vue&type=template&id=3cd1e379&scoped=true&"
import script from "./ItSupport.vue?vue&type=script&lang=js&"
export * from "./ItSupport.vue?vue&type=script&lang=js&"
import style0 from "./ItSupport.vue?vue&type=style&index=0&id=3cd1e379&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1e379",
  null
  
)

export default component.exports